import { createContext } from 'react'
import type { UIVariant, UIVariantResolution } from './types'

export type UIVariantStatus = 'resolving' | 'resolved' | 'failed'

export interface UIVariantContextValue {
  variant: UIVariant
  status: UIVariantStatus
  resolution: UIVariantResolution | null
}

const defaultValue: UIVariantContextValue = {
  variant: 'next',
  status: 'resolved',
  resolution: null,
}

/** Exported for tests that render consumers under a fixed value. */
export const UIVariantContext = createContext<UIVariantContextValue>(defaultValue)
